import { createContext } from "react";
const NerdConfirmContext = createContext({
    setOpen: () => {
        //Dummy function
        return;
    },
});
export { NerdConfirmContext };
